var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCertIconAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2814_89200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8516 10.9991L20.4116 8.21906L20.7516 4.53906L17.1416 3.71906L15.2516 0.539062L11.8516 1.99906L8.45156 0.539062L6.56156 3.71906L2.95156 4.52906L3.29156 8.20906L0.851562 10.9991L3.29156 13.7791L2.95156 17.4691L6.56156 18.2891L8.45156 21.4691L11.8516 19.9991L15.2516 21.4591L17.1416 18.2791L20.7516 17.4591L20.4116 13.7791L22.8516 10.9991ZM12.8516 15.9991H10.8516V13.9991H12.8516V15.9991ZM12.8516 11.9991H10.8516V5.99906H12.8516V11.9991Z",
    fill: "#FFA900"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2814_89200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0.851562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertIconAlert);
export default __webpack_public_path__ + "static/media/CertIconAlert.6da39282062f5d48a9249f35010715c4.svg";
export { ForwardRef as ReactComponent };